export default ["/quotation/quick-approval"];
